import { useEffect, useRef, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import { alpha } from '@mui/material/styles';

// project imports
import Transitions from 'ui-component/extended/Transitions';

// assets
import TranslateTwoToneIcon from '@mui/icons-material/TranslateTwoTone';
import useConfig from 'hooks/useConfig';

// types
import { I18n, ThemeMode } from 'types/config';
import Login from 'views/pages/authentication/Login3';
import Register from 'views/pages/authentication/Register3';
import { FormattedMessage } from 'react-intl';
import { Stack } from '@mui/material';

interface SimpleDialogProps {
    onClose: (s: string) => void;
    selectedValue: string;
    open: boolean;
}

// ==============================|| LOCALIZATION ||============================== //

const RegisterSection = ({ registerForceOpen, forceOpen }: { registerForceOpen: boolean; forceOpen: Function }) => {
    const { mode, borderRadius, i18n, onChangeLocale } = useConfig();

    const theme = useTheme();
    const downMD = useMediaQuery(theme.breakpoints.down('md'));

    const [open, setOpen] = useState(registerForceOpen || false);
    const anchorRef = useRef<any>(null);

    const handleListItemClick = (
        event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement, MouseEvent> | undefined,
        lng: I18n
    ) => {
        onChangeLocale(lng);
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event: MouseEvent | TouchEvent) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
        forceOpen('close');
    };

    const prevOpen = useRef(open);

    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);

    useEffect(() => {
        if (registerForceOpen) setOpen(true);
    }, [registerForceOpen]);

    const forceOpenFn = (type: string) => {
        forceOpen(type);
        setOpen(false);
    };
    return (
        <>
            <Box sx={{ ml: { xs: 2, sm: 2 } }}>
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                        // border: '1px solid',
                        borderRadius: '10px',
                        // borderColor: mode === ThemeMode.DARK ? 'dark.main' : 'primary.light',
                        // background: theme.palette.mode === ThemeMode.DARK ? theme.palette.grey[400] : theme.palette.common.white,
                        // background: '#FFBC45',
                        background: alpha(theme.palette.secondary.main, 1),
                        color: theme.palette.grey[500],
                        // color: '#121212',
                        cursor: 'pointer',
                        padding: '0px 10px',
                        fontSize: '1rem',
                        fontWeight: '800',
                        fontFamily: '"Manrope", sans-serif',
                        width: '138px',
                        height: '56px',
                        [theme.breakpoints.down('sm')]: {
                            width: '100px',
                            height: '44px',
                            fontSize: '0.875rem',
                            fontWeight: '600'
                        },
                        transition: 'all .2s ease-in-out',
                        '&[aria-controls="menu-list-grow"],&:hover': {
                            // background: theme.palette.mode === ThemeMode.DARK ? theme.palette.grey[400] : theme.palette.common.white,
                            background: alpha(theme.palette.secondary.main, 1),
                            color: theme.palette.grey[500]
                        }
                    }}
                    ref={anchorRef}
                    aria-controls={open ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    alt="language"
                    onClick={handleToggle}
                    color="inherit"
                >
                    <FormattedMessage id="Registration" />
                </Avatar>
            </Box>

            {open && (
                <Dialog
                    className="227788"
                    sx={{ borderRadius: '0px' }}
                    onClose={handleClose}
                    aria-labelledby="simple-dialog-title"
                    open={open}
                >
                    {open && (
                        <>
                            <Card className="343434" sx={{ overflow: 'auto', borderRadius: '0px', background: 'transparent' }}>
                                <CardContent sx={{ p: 0, borderRadius: '0px', background: '#fff', pb: '0px !important' }}>
                                    <Register forceOpen={forceOpenFn} />
                                </CardContent>
                            </Card>
                        </>
                    )}
                </Dialog>
            )}
        </>
    );
};

export default RegisterSection;
